<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('ymsIossRateSetting_insert')">
      <!--新增费率设置-->
      <Button class="mr15" type="primary" @click="$refs['taxRateSetting'].initTaxRateSettingData('add', tableData)">{{ $t('key1000718') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        :loading="tableLoading"
        border
        max-height="650"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG']" :showPage="true"></commonLogModal>
    <!--税率设置弹窗-->
    <taxRateSettingModal
      :countrysOriginalData="countrysOriginalData"
      @updateData="getList()"
      ref="taxRateSetting">
    </taxRateSettingModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import commonLogModal from "@/components/common/commonLogModal";
import taxRateSettingModal from "@/views/yms/components/basicSettings/taxRateSettingModal";
import {getAllCountrysData, getAllUsersInfo, getIossTaxRateData, getUserNameByUserId} from "@/utils/common";

export default {
  name: "iossTaxRateSetting",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002474'),
          key: 'countryCode',
          align: 'center',
          render(h, params) {
            let twoCode = params.row.countryCode || null;
            let text = '';
            if (v.countrysOriginalData.length > 0) {
              v.countrysOriginalData.map((item) => {
                if (item.twoCode === twoCode) {
                  text = item.cnName;
                }
              });
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002475'),
          key: 'rate',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let rate = params.row.rate || 0;
            let text = (rate * 100).toFixed(2) + '%';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002476'),
          key: 'updatedBy',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'),
          key: 'updatedTime',
          minWidth: 180,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let status = params.row.status;
            let ymsIossRateSettingId = params.row.ymsIossRateSettingId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsIossRateSetting_update'),
                    clickFn: () => {
                      v.$refs['taxRateSetting'].initTaxRateSettingData('edit', v.tableData, params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsIossRateSettingId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsIossRateSetting_enable'),
                    clickFn: () => {
                      v.enableDisableBtn('enable', ymsIossRateSettingId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsIossRateSetting_disable'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.enableDisableBtn('disable', ymsIossRateSettingId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      countrysOriginalData: [],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化数据
    initFun() {
      let v = this;
      (async () => {
        await getAllCountrysData().then((data) => {
          this.countrysOriginalData = data;
        });
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getList();
      })();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsIossRateSetting_query')) {
        v.tableLoading = true;
        getIossTaxRateData('yms').then((data) => {
          v.tableData = data;
          v.$nextTick(() => {
            v.tableLoading = false;
          });
        });
      } else {
        v.gotoError();
      }
    },
    // 启用、停用
    enableDisableBtn(type, ymsIossRateSettingId) {
      let v = this;
      let title = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002479') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002480');
      let content = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002481') :
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002482');
      let okText = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002483') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002484');
      let text = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486');
      let url = type === 'enable' ? api.put_ymsIossRateSetting_enable : api.put_ymsIossRateSetting_disable;
      v.$Modal.confirm({
        title: title,
        content: content,
        okText: okText,
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(url + ymsIossRateSettingId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(text);
              v.getList();
            }
          });
        },
        onCancel: () => {
        }
      });
    }
  },
  components: {
    commonLogModal,
    taxRateSettingModal
  }
};
</script>

<style lang="less" scoped>

</style>